import './form-splash-screen.scss';

import { SplashScreenFormSchema } from "@factory/form/form.rule";
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";
import ImageControl from '@shared/ui/hook-form/image-control/image-control';
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDateControl from "@shared/ui/hook-form/input-date-control/input-date-control";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import InputTextareaControl from '@shared/ui/hook-form/input-textarea-control/input-textarea-control';
import { Divider } from 'primereact/divider';
import { useFormContext } from "react-hook-form";

type InputFormSchema = SplashScreenFormSchema;
export function FormSplashScreen() {
  const { control } = useFormContext<SplashScreenFormSchema>();
  return (
    <div id="FormSplashScreen" className="splash-screen">
      <ImageControl<InputFormSchema>
        control={control}
        name="file"
        label="Image"
        imagePreviewClass="w-32 h-32"
      />

      <Divider />

      <InputControl<InputFormSchema>
        control={control}
        name="name"
        label="Name"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter name"
      />
      <InputTextareaControl<InputFormSchema>
        control={control}
        name="description"
        label="Description"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter description"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="link"
        label="Link"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter link"
      />
    </div>
  );
}

export default FormSplashScreen;
